import API from "../api";
import ICita from "../types/Cita";
import IClass from "../types/Class";
import IListaEspera from "../types/ListaEspera";
import IMasterClass from "../types/MasterClass";
import { Comprobaciones } from "../utils/Disponibilidad";

const getAll = () => API.get('/citas');
// comprobar: qué avisos pide comprobar la API al guardar (sala ocupada, no disponible, festivo y fuera de horario; false
// cuando el usuario ya ha dicho que quiere guardar igualmente)
const create = (data: ICita, comprobar: Comprobaciones) => API.post('/citas', {data, ...comprobar});
const update = (_id: string, data: ICita, comprobar: Comprobaciones) => API.patch(`/cita${_id}`, {data, ...comprobar});
const deleteCita = (_id: string) => API.delete(`/cita${_id}`);

const setCitaNoAsistida = (_id: string) => API.patch(`/citaNoAsistida/${_id}`);

const createRecurrence = (data: ICita, comprobar: Comprobaciones) => API.post('/citasRec', {...data, ...comprobar});
const deleteRecurrence = (_id: string) => API.delete(`/citasRec/${_id}`); 

const getCitaActualPaciente = (_id: string) => API.get(`/citaactual/${_id}`);
const getCitasPaciente = (_id: string) => API.get(`/cita${_id}`);
const getCitasPasadasPaciente = (_id: string) => API.get(`/oldcita${_id}`);

const createClasses = (data: IMasterClass[], comprobar: Comprobaciones) => API.post('/classes', {masters: data, ...comprobar});
const getAllClasses = () => API.get('/classes');
const deleteClasses = (_ids: string[]) => API.delete(`/classes/${_ids}`);

const getMasterClasses = () => API.get('/masterclasses');
const updateMasterClasses = (data: IMasterClass[], type: number, comprobar: Comprobaciones) => API.patch(`/masterclasses${type}`, {masters: data, ...comprobar});
const modifyPacientes = (data: IMasterClass[]) => API.patch('/masterpacientes', data);
const getPacientesActivos = () => API.get('/activos');

const updateClass = (_id: string, data: IClass, comprobar: Comprobaciones) => API.patch(`/class${_id}`, {data, ...comprobar});
const addComentarioClass = (_id: string, data: any) => API.patch(`/comentarios${_id}`, data);
const deleteClase = (_id: string) => API.delete(`/class${_id}`);

const sendJustificante = (data: any) => API.post('/sendJustificante', data);
const sendConfirmacion = (data: any) => API.post('/sendConfirmacion', data);

const createListaEspera = (data: IListaEspera[]) => API.post('/listaespera', data);
const updateListaEspera = (_id: string, data: IListaEspera) => API.patch(`/listaespera${_id}`, data);
const getListaEsperaFiltered = (actividadIds: number[], weekdays: number[], horarioId: number) => API.get(`listaespera/${actividadIds}/${weekdays}/${horarioId}`);
const getAllListaEspera = () => API.get('listaespera');
const deleteListaEspera = (_id: string) => API.delete(`/listaespera${_id}`);

const deletePacienteFromMasterClass = (masterId: string, pacienteId: string) => API.delete(`/clases/${masterId}/pacientes/${pacienteId}`);

const getEstadoFacturacionCita = (citaId: string) => API.get(`/citas/${citaId}/estado-facturacion`);

const AgendaService = {
    getAll,
    create,
    update,
    deleteCita,
    getCitaActualPaciente,
    getCitasPaciente,
    getCitasPasadasPaciente,
    createRecurrence,
    deleteRecurrence,
    createClasses,
    getAllClasses,
    deleteClasses,
    getMasterClasses,
    getPacientesActivos,
    updateMasterClasses,
    modifyPacientes,
    updateClass,
    deleteClase,
    sendJustificante,
    addComentarioClass,
    setCitaNoAsistida,
    sendConfirmacion,
    createListaEspera,
    getAllListaEspera,
    getListaEsperaFiltered,
    deleteListaEspera,
    updateListaEspera,
    deletePacienteFromMasterClass,
    getEstadoFacturacionCita
};

export default AgendaService;